import React from 'react'
import styled from 'styled-components'

export function Version() {
  return <Text>Version {VERSION}</Text>
}

const Text = styled.div`
  font-size: 12px;
  text-transform: uppercase;
`
